/**
 * Route path constants.
 *
 * Centralized route paths to prevent typos and make route changes easier.
 * This file contains only constants and no component imports to avoid circular dependencies.
 *
 * @module routeConstants
 */

/**
 * Route path constants.
 * Centralized route paths to prevent typos and make route changes easier.
 */
export const ROUTES = {
  LANDING: '/',
  DASHBOARD: '/dashboard',
  SIGN_IN: '/signin',
  SIGN_UP: '/signup',
  EXAM: '/exam',
  /** Legacy path; redirects to {@link ROUTES.EXAM}. */
  EXAM_SIMULATION: '/exam/simulation',
  LEARNING: '/learning',
  LEARNING_GRAMMAR: '/learning/grammar',
  LEARNING_SENTENCES: '/learning/sentences',
  LEARNING_BOOKS: '/learning/books',
  LEARNING_GRAMMAR_TOPIC: '/learning/grammar/:level/:topicId',
  PARTNERS: '/partners',
  PARTNERS_FIND: '/partners/find',
  PARTNERS_REQUEST: '/partners/request',
  PARTNERS_REQUEST_EDIT: '/partners/request/edit',
  PARTNERS_MESSAGES: '/partners/messages',
  ADMIN: '/admin',
  ADMIN_USERS: '/admin/users',
  ADMIN_QUESTIONS: '/admin/questions',
  ADMIN_CONTEXTS: '/admin/contexts',
  ADMIN_TITLES: '/admin/titles',
  ADMIN_INTRODUCTION: '/admin/introduction',
  ADMIN_GENERATION: '/admin/generation',
  ADMIN_SIMULATIONS: '/admin/simulations',
  ADMIN_ANSWERS: '/admin/answers',
  ADMIN_FEEDBACK: '/admin/feedback',
  ADMIN_MODERATION: '/admin/moderation',
  ADMIN_ANALYTICS: '/admin/analytics',
  ADMIN_TOKEN_USAGE: '/admin/token-usage',
  ADMIN_ACTIVATION: '/admin/activation',
  ADMIN_PLANS: '/admin/plans',
  ADMIN_BACKUP: '/admin/backup',
  ADMIN_HUMAN_REVIEWS: '/admin/human-reviews',
  ADMIN_DIAGNOSTIC_REVIEW: '/admin/diagnostic-review',
  RESULTS: '/results',
  RESULTS_REVIEW: '/results/:sessionId/:moduleName',
  HUMAN_REVIEWS: '/human-reviews',
  DIAGNOSTIC_PROFILE: '/diagnostic-profile',
  FEEDBACK: '/feedback',
  SETTINGS: '/settings',
  CONSENT: '/consent',
  PRIVACY: '/privacy',
  TERMS: '/terms',
  IMPRINT: '/imprint',
} as const;
